import CheckIcon from "@mui/icons-material/Check";
import { Box, BoxProps, useTheme } from "@mui/material";
import { getContrastingTextColor } from "@caredna-marlin/map-wrapper/helpers";
import { isValidHexColor, toSixDigitHex } from "@caredna-marlin/utils/colors";

type Props = {
  value: string,
  onChange: (newValue: string) => void,
  palette: readonly string[],
  disabled?: boolean,
  sx?: BoxProps["sx"],
};

const ColorPicker = ({ value, onChange, palette, disabled, sx }: Props) => {
  const isPresetColor = palette.includes(value);
  const theme = useTheme()

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center', ...sx }}>
      {palette.map((color) => (
        <Box
          key={color}
          onClick={() => !disabled && onChange(color)}
          sx={{
            width: 32,
            height: 32,
            borderRadius: '6px',
            backgroundColor: color,
            cursor: disabled ? 'default' : 'pointer',
            border: value === color ? `2px solid ${theme.palette.primary.main}` : '1px solid rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {value === color && (
            <CheckIcon fontSize="small" sx={{ color: getContrastingTextColor(color) }} />
          )}
        </Box>
      ))}
      <Box
        component="label"
        title="Custom color"
        sx={{
          position: 'relative',
          width: 32,
          height: 32,
          borderRadius: '6px',
          overflow: 'hidden',
          background: isPresetColor
            ? 'conic-gradient(from 90deg, red, yellow, lime, aqua, blue, magenta, red)'
            : value,
          cursor: disabled ? 'default' : 'pointer',
          border: !isPresetColor ? `2px solid ${theme.palette.primary.main}` : '1px solid rgba(0,0,0,0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <input
          type="color"
          aria-label="Custom color"
          value={isValidHexColor(value) ? toSixDigitHex(value) : '#000000'}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          style={{
            position: 'absolute',
            inset: -4,
            width: 'calc(100% + 8px)',
            height: 'calc(100% + 8px)',
            border: 'none',
            padding: 0,
            opacity: 0,
            cursor: disabled ? 'default' : 'pointer',
          }}
        />
        {!isPresetColor && (
          <CheckIcon
            fontSize="small"
            sx={{ pointerEvents: 'none', color: getContrastingTextColor(value) }}
          />
        )}
      </Box>
    </Box>
  );
};

export default ColorPicker;
